import SquareCard from './SquareCard';

export default SquareCard;
